export default "__VITE_PUBLIC_ASSET__8c25f595__"